<template>
  <div class="dialog-warp">
    <el-form ref="info" :model="info" :rules="rules" size="mini" label-width="130px">
      <h3 class="title">基础信息：</h3>
      <el-row class="dialog-form" >
        <el-col :span="18" :offset="2">
          <el-form-item label="票据类型：" prop="noteType">
            <el-radio-group v-model="info.noteType">
              <el-radio :label="1">普票</el-radio>
              <el-radio :label="2">专票</el-radio>
              <el-radio :label="3">收据</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="选择合同：">
            <el-cascader
                ref="contractCascader"
                :props="{label:'contractContent',value:'contractId',children:'contracts'}"
                v-model="ContractInfoSelect"
                :options="ContractInfoList"
                style="width: 387px;"
                @change="changeSelectContract"
              ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="选择账单：">
            <el-select v-model.trim="info.noteBillInfo" placeholder="请选择账单" ref="billCascader">
              <el-option v-for="(item,index) in BillInfoList" :key="item.noteBillInfo"
                         :value="item.noteBillInfo" class="flex-box text-space" style="justify-content: space-between;">
                <span>{{item.allBillType|billTypeNew}}</span>
                <span>{{item.allBillStartTime|date}} ~{{item.allBillEndTime|date}} </span>
                        </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="情况描述：" prop="noteDescription">
            <el-input type="textarea" v-model="info.noteDescription" placeholder="请输入情况描述" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="票据附件：" prop="noteVoucherFile">
            <v-upload-file :size="20" :number="3" @onFileChange="onFileChangeBills"></v-upload-file>
          </el-form-item>
        </el-col>
      </el-row>
      <h3 class="title" v-if="info.noteType==1||info.noteType==2">发票抬头信息：</h3>
      <el-row class="dialog-form" v-if="info.noteType==1||info.noteType==2">
        <el-col :span="18" :offset="2">
          <el-form-item label="纳税人识别号：" prop="noteTaxpayer">
            <el-input v-model="info.noteTaxpayer" placeholder="请输入纳税人识别号" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="地址：" prop="noteAddress">
            <el-input v-model="info.noteAddress" placeholder="请输入地址" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="电话：" prop="notePhone">
            <el-input v-model="info.notePhone" placeholder="请输入电话" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="开户行：" prop="noteBank">
            <el-input v-model="info.noteBank" placeholder="请输入开户行" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" :offset="2">
          <el-form-item label="帐号：" prop="noteAccount">
            <el-input v-model="info.noteAccount" placeholder="请输入帐号" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="text-center" style="margin-top: 20px;">
      <el-button  @click="close">取 消</el-button>
      <el-button type="success" @click="submit" :loading="submitLoading">生成</el-button>
    </div>
  </div>
</template>

<script>
  import * as getData from "../service/getData";
  import * as global from "../config/mUtils";

  export default {
    data() {
      return {
        isSave:false,
        submitLoading: false,
        sellOptions:[],
        checkOptions:[],
        dateSection:[],
        info: {
          noteType:'',
          noteCompanyName:'',
          noteBillInfo: '',
          noteContractInfo: '',
          noteDescription:'',
          invoiceMakeFileNames:'',
          noteVoucherFile:'',
          noteTaxpayer:'',
          noteAddress:'',
          notePhone:'',
          noteBank:'',
          noteAccount:'',
        },
        rules: {
          noteType: [
            { required: true, message: "请选择发票类型", trigger: ["blur", "change"] }
          ],
          noteCompanyName: [
            { required: true, message: "请输入企业名称", trigger: ["blur", "change"] }
          ],
          noteDescription: [
            { required: true, message: "请输入情况描述", trigger: ["blur", "change"] }
          ],
          noteVoucherFile: [
            { required: true, message: "请选择文件", trigger: ["blur", "change"] }
          ],

          noteTaxpayer: [
            { required: true, message: "请输入纳税识别号 ", trigger: ["blur", "change"] }
          ],
          noteAddress: [
            { required: true, message: "请输入地址 ", trigger: ["blur", "change"] }
          ],
          notePhone: [
            { required: true, message: "请输入电话 ", trigger: ["blur", "change"] }
          ],
          noteBank: [
            { required: true, message: "请输入开户行 ", trigger: ["blur", "change"] }
          ],
          noteAccount: [
            { required: true, message: "请输入帐号 ", trigger: ["blur", "change"] }
          ],

        },
        invoiceDefaultIsHaveNumber:0,
        BillInfoList: [],
        ContractInfoList: [],
        ContractInfoSelect: [],
        contractId: ''
      };
    },
    created() {
    },
    mounted() {
      this.getContracts();//获取合同下拉列表
      // this.getBills();//获取账单下拉列表
      this.init();
    },
    props: [],
    computed: {},
    methods: {
      changeSelectContract(val){//选择合同
        let tempId = this.$refs['contractCascader'].getCheckedNodes()[0].data.contractId;
        this.contractId = tempId.substr(2)
        if(val&&val.length){
          this.getBills(this.contractId,val[0])
          let str = ''
          this.ContractInfoList.forEach( item =>{
            if(item.contractId == val[0]){
              str = item.contractContent;
              item.contracts.forEach(ele =>{
                if(ele.contractId == val[1]){
                  str = str+ '/' +ele.contractContent;
                }
              })
            }
          })
          this.info.noteContractInfo=str
        }
        this.info.noteBillInfo = ''
      },
      getContracts(){//处理级联数据，生成唯一id拼接显示
        getData.getContracts().then(res => {
          if(res.data.code == 1 || res.data.code == 'success'){
            let arr = res.data.data || [];
            if(arr.length){
              arr.forEach((ele,index) =>{
                ele.contracts.forEach((item) =>{
                  if(ele.contractId == 1){//租赁
                    item.contractId = 'ZL'+item.contractId
                  }else if(ele.contractId == 2){//物业
                    item.contractId = 'WY'+item.contractId
                  }else if(ele.contractId == 3){//车位
                    item.contractId = 'CW'+item.contractId
                  }else if(ele.contractId == 4){//公寓租赁
                    item.contractId = 'GZ'+item.contractId
                  }else if(ele.contractId == 5){//公寓物业
                    item.contractId = 'GW'+item.contractId
                  }
                  item.contractContent = item.contractNumber+'   ('+new Date(item.contractStartTime).format('yyyy-MM-dd')+'~'+new Date(item.contractEndTime).format('yyyy-MM-dd')+')'
                })
              });
              
              this.ContractInfoList = arr||[];
              console.log(this.ContractInfoList);
            }
          }
        }).catch(err => {
        });
      },
      getBills(contractId,type){
        getData.getBills({contractId:contractId,contractType:type}).then(res => {
          if(res.data.code == 1 || res.data.code == 'success'){
            this.BillInfoList = res.data.data || [];
            this.BillInfoList.forEach((ele,index) =>{
              let billType = global.billTypeNew(ele.allBillType)
              ele.noteBillInfo = billType+'/'+new Date(ele.allBillStartTime).format('yyyy-MM-dd')+'~'+new Date(ele.allBillEndTime).format('yyyy-MM-dd');
            })
            console.log(this.BillInfoList);
          }
        }).catch(err => {
        });
      },
      close(type) {
        if (type === 1) {
          this.$emit("init");
        }
        this.$emit("closeDialog");
      },
      onFileChangeBills(obj) {
        let url = [];
        obj.fileList.forEach(item => {
            url.push(item)
        });
        this.info.noteVoucherFile = JSON.stringify(url);
      },
      init(){
        getData.noteCompanyDetail().then(res => {
          this.info.noteTaxpayer = res.data.data.noteTaxpayer;
          this.info.noteAddress = res.data.data.noteAddress;
          this.info.notePhone = res.data.data.notePhone;
          this.info.noteBank = res.data.data.noteBank;
          this.info.noteAccount = res.data.data.noteAccount;
          // this.info = Object.assign(this.info,res.data.data)

        }).catch(err => {
          this.submitLoading = false;
          this.$message.error("服务器开小差了...");
        });
      },
      submit() {
        this.submitLoading = true;
        this.$refs["info"].validate((valid) => {
          if (valid) {
            this.info.isPreserve = this.isSave ? 1 : 0 ;
            getData.noteAddNote(this.info).then(res => {
              this.submitLoading = false;
              if (res.data.code == 1) {
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.close(1);
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch(err => {
              this.submitLoading = false;
              this.$message.error("服务器开小差了...");
            });

          } else {
            this.submitLoading = false;
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    components: {},
    watch: {}
  };
</script>
<style  lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/create-invoice.vue